exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-17d66502] .allSelBtnDis .cell {\n  visibility: hidden;\n}\n", ""]);

// exports
